import { render, staticRenderFns } from "./Approvers.vue?vue&type=template&id=a55f6b34"
import script from "./Approvers.js?vue&type=script&lang=js&external"
export * from "./Approvers.js?vue&type=script&lang=js&external"
import style0 from "./Approvers.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports